import { produce } from 'immer';
import { OnboardingAction, OnboardingState } from './choose-journey-types';
import {
  ONBOARDING_REQUEST,
  ONBOARDING_REQUEST_FAILED,
  ONBOARDING_REQUEST_SUCCESS,
  ONBOARDING_FIRST_FIELD_DROPPED,
  ONBOARDING_FIRST_FIELD_DROPPED_FAILED,
  ONBOARDING_DONT_SHOW_FIELD_ICON,
  ONBOARDING_DONT_SHOW_FIELD_ICON_FAILED,
  ONBOARDING_STEPS_REQUEST,
  ONBOARDING_STEPS_REQUEST_SUCCESS,
  ONBOARDING_STEPS_REQUEST_FAILED,
  ONBOARDING_COMPLETED_ITEMS_REQUEST,
  ONBOARDING_COMPLETED_ITEMS_REQUEST_SUCCESS,
  ONBOARDING_COMPLETED_ITEMS_REQUEST_FAILED,
  ONBOARDING_CHANGE_STEP,
  ONBOARDING_COMPLETE_ITEM
} from './actions';
import { completeItem } from './updater';

const initialState: OnboardingState = {
  completedItems: {},
  completionStateloaded: false,
  currentStep: 1,
  stepsLoaded: false
};

export default function onboarding(existingState: OnboardingState = initialState, action: OnboardingAction) {
  if (!action) {
    return existingState;
  }

  return produce(existingState, (state: OnboardingState) => {
    const { payload, type } = action;

    switch (type) {
      case ONBOARDING_REQUEST:
        state.completionStateloaded = false;
        delete state.errorMessage;
        return;

      case ONBOARDING_REQUEST_SUCCESS:
        state.completedItems = payload.completedItems;
        state.completionStateloaded = true;
        state.currentStep = payload.currentStep;
        state.dontShowOnboardingFieldIcon = payload.dontShowOnboardingFieldIcon;
        state.hasDroppedFirstField = payload.hasDroppedFirstField;
        return state;

      case ONBOARDING_REQUEST_FAILED:
        state.errorMessage = payload.errorMessage;
        state.completionStateloaded = false;
        return;

      case ONBOARDING_FIRST_FIELD_DROPPED:
        state.hasDroppedFirstField = payload.hasDroppedFirstField;
        return;

      case ONBOARDING_FIRST_FIELD_DROPPED_FAILED:
        state.errorMessage = payload.errorMessage;
        state.hasDroppedFirstField = false;
        return;

      case ONBOARDING_DONT_SHOW_FIELD_ICON:
        state.dontShowOnboardingFieldIcon = payload.dontShowOnboardingFieldIcon;
        return;

      case ONBOARDING_DONT_SHOW_FIELD_ICON_FAILED:
        state.errorMessage = payload.errorMessage;
        state.dontShowOnboardingFieldIcon = payload.dontShowOnboardingFieldIcon;
        return;

      case ONBOARDING_STEPS_REQUEST:
        state.stepsLoaded = false;
        delete state.errorMessage;
        return state;

      case ONBOARDING_STEPS_REQUEST_SUCCESS:
        state.stepsLoaded = true;
        state.steps = payload.steps;
        return;

      case ONBOARDING_STEPS_REQUEST_FAILED:
        state.stepsLoaded = false;
        state.errorMessage = payload.errorMessage;
        delete state.steps;
        return;

      case ONBOARDING_COMPLETED_ITEMS_REQUEST:
        state.completingItems = true;
        delete state.errorMessage;
        return;

      case ONBOARDING_COMPLETED_ITEMS_REQUEST_SUCCESS:
        state.completingItems = false;
        return;

      case ONBOARDING_COMPLETED_ITEMS_REQUEST_FAILED:
        state.completingItems = false;
        state.errorMessage = payload.errorMessage;
        return;

      case ONBOARDING_CHANGE_STEP:
        state.currentStep = payload.currentStep;
        return;

      case ONBOARDING_COMPLETE_ITEM:
        return completeItem(state, payload.currentStep, payload.itemNo);

      default:
        return state;
    }
  });
}
